import { BoothService } from './../../booth/booth.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../../http.service';
import { GlobalService } from '../../global.service';
import { BoothTypeService } from '../../booth/booth-type.service';

@Component({
  selector: 'app-booth-type-register',
  templateUrl: './booth-type-register.component.html',
  styleUrls: ['./booth-type-register.component.scss']
})
export class BoothTypeRegisterComponent {
  action: 'register' | 'update' = null;
  booth_type_register_form: FormGroup;

  constructor(private formBuilder: FormBuilder, private http: HttpService, private global: GlobalService, private boothTypeService: BoothTypeService) {
    this.booth_type_register_form = this.formBuilder.group({
      id: [null, Validators.compose([])],
      name: [null, Validators.compose([Validators.required])],
      code: [null, Validators.compose([Validators.required])]
    });

    if (this.boothTypeService.get_booth_type_data === null) {
      this.action = 'register';
    } else {
      this.action = 'update';
      this.setupUpdateForm(this.boothTypeService.get_booth_type_data);
    }

    this.boothTypeService.boothTypeUpdate.subscribe((booth) => {
      console.log(booth);
      console.log(booth);
      if (booth === null) {
        this.action = 'register';
        this.booth_type_register_form.reset();
      } else {
        this.action = 'update';
        this.setupUpdateForm(booth);
      }
    });
  }

  registerBoothType() {
    this.http.registerBoothType(this.booth_type_register_form.value).subscribe((data) => {
      console.log(data);
      this.booth_type_register_form.reset();
      this.global.showSnakeBar(data['message']);
      this.boothTypeService.downloadBoothType.emit(true);
    }, (error) => {
      console.log(error);
    });
  }

  setupUpdateForm(booth) {
    this.booth_type_register_form.controls['id'].setValue(booth['id']);
    this.booth_type_register_form.controls['name'].setValue(booth['name']);
    this.booth_type_register_form.controls['code'].setValue(booth['code']);
  }

}
